/**
 * Formats a date into a relative time string (e.g., "2 hours ago", "Just now")
 * @param date - The date to format
 * @returns Relative time string
 */
export function formatRelativeTime(date: Date): string {
  const rtf = new Intl.RelativeTimeFormat('en', { numeric: 'auto' });
  const intervals = [
    { unit: 'year' as const, seconds: 31536000 },
    { unit: 'month' as const, seconds: 2592000 },
    { unit: 'day' as const, seconds: 86400 },
    { unit: 'hour' as const, seconds: 3600 },
    { unit: 'minute' as const, seconds: 60 }
  ];

  const secondsAgo = Math.floor((Date.now() - date.getTime()) / 1000);

  if (secondsAgo < 60) return 'Just now';

  for (const { unit, seconds } of intervals) {
    const count = Math.floor(secondsAgo / seconds);
    if (count >= 1) return rtf.format(-count, unit);
  }

  return 'Just now';
}
